import { getFriend, queryFrontSingleNavigationMenuList } from './../../api/getListData';
import { cornerMarkModuleList, layoutPublicUrl, TEAMS } from './../../constants/index';
import { observable, action, runInAction, toJS } from 'mobx';
import { mockData } from '../../mock';
import * as API from '../../api/getListData';
import { getLocationOrigin, inApp, isExternalTest, mainHost } from '../../utils';
import { getLabel, request, setTitle, weappSDK } from "@weapp/utils";
import { MDialog, IconSelection } from "@weapp/ui";
import { MenuItem, NavMenuItem } from './types';
import { queryExternalEmployees, getNavMenuList } from '../../api/mainApi';

const { getIconInfo } = IconSelection;
const { toast } = MDialog
const host = mainHost();

//类型
export enum QuickMenuType {
    APP_NEW_PAGE = "1", //应用新建页面
    SYSTEM_MENU = "2",  //系统菜单
    CUSTOM_URL = "3", //自定义URL
    LINE = "LINE", //分割线
}


export class MobMainStore {

    @observable allAppMenus: Array<any> = []; //所有应用
    @observable allAppMenusIdMap: any = {};
    @observable frequentlyUseMenus: any[] = [];//常用应用
    @observable unfinishedCount: number = 0; //未完成
    @observable watchCount: number = 0; //关注
    @observable waitCount: number = 0; //待办事项数量
    @observable createMenus: Array<any> = [] //新建菜单
    @observable myFriendMenu: any = {}
    @observable myFriendMenuCount: number = 0
    @observable focusPeopleCount: number = 0 //
    @observable menuList: Array<MenuItem> = []
    @observable externalEmployeesList = [] //外部身份列表
    @observable navMenuList: Array<NavMenuItem> = [] //底部菜单列表
    @observable moreNavMenuList = [] //底部上划显示的菜单
    @observable showMoreNavMenu = false;
    @observable cornerMarkValue = {
        me: 0
    }
    @observable allowEmpSetting = true;
    @observable moreMenuList = [
        { content: getLabel('72864', '应用列表设置'), icon: 'Icon-set-up-o', id: 'appListSetting' },
        { content: getLabel('28479', '列表视图'), icon: 'Icon-operation02', id: 'listView' },
        { content: getLabel('72859', '图标视图1'), icon: 'Icon-Category-view', id: 'iconView1' },
        { content: getLabel('72861', '图标视图2'), icon: 'Icon-custom38-o', id: 'iconView2' }
    ]


    @action
    doInit = () => {
        // const portalConfigLoaded = window.sessionStorage?.getItem('portalConfigLoaded');
        // if (!portalConfigLoaded) {
        //     this.checkPortalConfig();
        // }
    }


    @action
    loadEmpAppConfig = () => {
        API.queryEmpAppManageConfigs().then((res: any) => {
            if (res && res.data) {
                res.data.forEach((config: any) => {
                    if (config.configKey === "allowEmpSetting") {
                        runInAction(() => {
                            if (config.configValue === '0') {
                                this.moreMenuList = [
                                    { content: getLabel('28479', '列表视图'), icon: 'Icon-operation02', id: 'listView' },
                                    { content: getLabel('72859', '图标视图1'), icon: 'Icon-Category-view', id: 'iconView1' },
                                    { content: getLabel('72861', '图标视图2'), icon: 'Icon-custom38-o', id: 'iconView2' }
                                ]
                            }
                        });
                    }
                })
            }
        })
    }

    @action
    loadedPortalConfig = () => { //应用模块store调用
        const portalConfigLoaded = window.sessionStorage?.getItem('portalConfigLoaded');
        if (!portalConfigLoaded) {
            this.checkPortalConfig();
        }
    }

    @action
    checkPortalConfig = () => {
        API.checkPortalConfig().then((data: any) => {
            sessionStorage.setItem('portalConfigLoaded', 'true');
            if (data && data.data && data.data.msgInfo === 'fixed') {
                if (inApp()) {
                    weappSDK.customSDK.invoke("openLink", {
                        url: `${layoutPublicUrl}/mobile/portal/view/${data.data.hpid}`,
                        openType: 2,
                        hideNavegation: 0,
                        success: function (res: any) { }
                    });
                } else {
                    window.location.href = `${layoutPublicUrl}/mobile/portal/view/${data.data.hpid}`
                }
            }
        })
    }
    @action
    getModuleCornerMark = () => {
        let allAppMenus = toJS(this.allAppMenus);
        allAppMenus.forEach((menuItem, menuItemIndex) => {
            if (menuItem.menus) {
                menuItem.menus.forEach((menu: any, menuIndex: number) => {
                    const menuType = menuItem['categoryType'];//判断是标准应用还是自定义应用
                    if (menu.cornerMark && menu.cornerMark !== '0') {
                        let params = {
                            cornerType: menu.cornerMark === '2' ? 1 : 2,//1显示数字，其他值显示红点
                            maxCornerCount: 99,
                            name: menu.menuname
                        } as any;
                        if (params.cornerType !== 1) {//非数字时删除最大量
                            delete params.maxCornerCount;
                        }
                        // if (menuType === "custom") {//自定义应用
                        if (menu?.cornerMarkData && menu?.cornerMark && menu?.cornerMark !== '0') {
                            request({
                                url: `${menu.cornerMarkData}`,
                                method: "get",
                                params
                            }).then((result: any) => {
                                runInAction(() => {
                                    if (!result?.data) {
                                        allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {}
                                    } else {
                                        if (menu.cornerMark === '1') {//显示红点时-判断data > 0
                                            if (result.data > 0) {
                                                allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                    type: 'showDot',
                                                }
                                            }
                                        }
                                        if (menu.cornerMark === '2') {//显示数字时-data是否大于可显示的最大数字
                                            if (result.data) {
                                                if (result.data > params.maxCornerCount) {
                                                    allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                        type: 'showNum',
                                                        maxNum: params.maxCornerCount + '+'
                                                    }
                                                } else {
                                                    allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                        type: 'showNum',
                                                        maxNum: result.data
                                                    }
                                                }
                                            }

                                        }
                                        if (menu.cornerMark === '3') {//自定义图标-判断data > 0
                                            if (result.data > 0) {
                                                allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                    type: 'showCustomIcon',
                                                }
                                            }
                                        }
                                    }


                                    this.allAppMenus = [...allAppMenus];
                                })

                            });
                        }
                        else {//标准应用
                            const isNeedGetCornerMark = cornerMarkModuleList.find((cornerInitData) => menu.id && cornerInitData.id === menu.id);
                            if (isNeedGetCornerMark) {
                                request({
                                    url: `${isNeedGetCornerMark.apiPath}`,
                                    method: "get",
                                    params
                                }).then((result: any) => {
                                    runInAction(() => {
                                        if (!result.data) {
                                            allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {}
                                        } else {
                                            if (menu.cornerMark === '1') {//显示红点时-判断data > 0
                                                if (result.data > 0) {
                                                    allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                        type: 'showDot',
                                                    }
                                                }
                                            }
                                            if (menu.cornerMark === '2') {//显示数字时-data是否大于可显示的最大数字
                                                if (result.data) {
                                                    if (result.data > params.maxCornerCount) {
                                                        allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                            type: 'showNum',
                                                            maxNum: params.maxCornerCount + '+'
                                                        }
                                                    } else {
                                                        allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                            type: 'showNum',
                                                            maxNum: result.data
                                                        }
                                                    }
                                                }
                                            }

                                            if (menu.cornerMark === '3') {//自定义图标-判断data > 0
                                                if (result.data > 0) {
                                                    allAppMenus[menuItemIndex]['menus'][menuIndex].cornerMarkCustomInfo = {
                                                        type: 'showCustomIcon',
                                                    }
                                                }
                                            }
                                        }

                                        this.allAppMenus = [...allAppMenus];
                                    })

                                });
                            }
                        }


                    }


                });
            }
            // menuItem.
        })
    }
    @action
    loadApplications = (callback?: Function) => {
        API.getMobileApplications().then((data: any) => {
            runInAction(() => {
                if (data.data) {
                    this.allAppMenus = data.data;

                    //生成提供常用菜单id映射的应用map
                    let menuIdMap: any = {};
                    data.data.forEach((group: any) => {
                        group.menus && group.menus.forEach((item: any) => {
                            menuIdMap[item.id] = item;
                        })
                    })
                    this.allAppMenusIdMap = menuIdMap;
                    this.getModuleCornerMark();
                }
                callback && callback();
            });
        })
    }

    @action
    getFrequentlyUseMenus = () => {
        API.getApplicationsFrequentlyUsed().then((result: any) => {
            runInAction(() => {
                if (result && result.data) {
                    this.frequentlyUseMenus = result.data;
                }
            });
        });
    }

    @action
    saveConfiguration = (type: any) => {
        API.saveConfiguration({ 'configKey': 'application.h5.display.type', 'configValue': type }).then((res: any) => {
            runInAction(() => {
                let teamsLocalData = localStorage.getItem('E10_TEAMS_LOCAL')
                if (teamsLocalData) {
                    try {
                        const teamsLocalDataObj = (JSON.parse(teamsLocalData)) as any;
                        if (!teamsLocalDataObj?.userConfig) {
                            teamsLocalDataObj.userConfig = {}
                        }
                        teamsLocalDataObj.userConfig['application.h5.display.type'] = type;
                        localStorage.setItem('E10_TEAMS_LOCAL', JSON.stringify(teamsLocalDataObj))
                    } catch (error) {

                    }
                }

            });
        })
    }

    @action
    loadUnfinishedCount = () => {
        API.getUnfinishCount().then((res: any) => {
            runInAction(() => {
                if (res) {
                    this.unfinishedCount = res.data.count;
                }
            });
        })
    }
    @action
    loadWatchCount = () => {
        API.queryWatchEntity().then((res: any) => {
            runInAction(() => {
                if (res && res.data && res.data.count) {
                    for (let key in res.data.count) {
                        this.watchCount = this.watchCount + res.data.count[key];
                    }
                }

            });
        })
    }
    @action
    loadWaitCount = () => {
        API.queryWaitCount().then(({ status, data, msg }) => {
            runInAction(() => {
                if (status) {
                    this.waitCount = data?.count || 0
                }
            });
        })
    }

    getDefaultEbIcon(module: string) {
        const iconInfo = getIconInfo(module);
        return {
            "path": "#" + (iconInfo.icon_line ? iconInfo.icon_line : 'icon-custom01-o'),
            "style": {
                "color": "#ffffff",
                "fontSize": 46,
                "radius": "23px",
                "fillType": "backgroundColor",
                "bgColor": iconInfo.color ? iconInfo.color : "#ffcd50"
            }
        }
    }

    @action
    loadCreateMenus = () => {
        return new Promise((res, rej) => {
            API.getMobileEmpMenuEntrances().then((result: any) => {
                runInAction(() => {
                    const newMenus = result.data.map((menu: any) => {
                        if (menu.quickType === QuickMenuType.APP_NEW_PAGE) {
                            // url为移动端快捷新建应用访问路由，quickUrl为流程和表单的数据，需要进一步拼接地址。
                            const { url, name, quickUrl, quickIcon, moduleStr } = menu;
                            let tempUrl = url;
                            if (quickUrl) {
                                try {
                                    const urlObj = JSON.parse(quickUrl)[0];
                                    const urlType = urlObj._entityType;

                                    const workflowId = urlObj.activeWfId ? urlObj.activeWfId : urlObj.id;
                                    const formId = urlObj.id;

                                    if (urlType === 'formdatareport') {
                                        tempUrl = "/sp/formreport/internal/main/" + formId;
                                    } else if (urlType === 'workflow') {
                                        tempUrl = `/mobile/workflow/flowpage/create/${workflowId}`;
                                    }
                                } catch (error) {

                                }
                            };

                            let tempIcon = quickIcon;
                            try {
                                if (quickIcon) {
                                    tempIcon = JSON.parse(quickIcon);
                                    // 兼容老数据保存生成了#undefined的数据 ---start
                                    if (tempIcon.path === '#undefined') {
                                        tempIcon.path = '#icon-custom01-o';
                                    }

                                    if (!tempIcon.style?.bgColor) {
                                        tempIcon.style.bgColor = "#ffcd50";
                                    }
                                    // 兼容老数据保存生成了#undefined的数据 ---end
                                } else {
                                    tempIcon = this.getDefaultEbIcon(moduleStr);
                                }
                            } catch (error) {

                            }

                            return {
                                name: name,
                                path: tempUrl,
                                icon: tempIcon
                            }
                        } else if (menu.quickType === QuickMenuType.CUSTOM_URL) {
                            const { name, quickUrl, quickIcon, moduleStr } = menu;

                            let tempIcon = quickIcon;
                            try {
                                if (quickIcon) {
                                    tempIcon = JSON.parse(quickIcon);
                                } else {
                                    tempIcon = this.getDefaultEbIcon(moduleStr);
                                }
                            } catch (error) {

                            }

                            return {
                                name: name,
                                path: quickUrl,
                                icon: tempIcon
                            }
                        }
                        return {
                            name: menu.name,
                            path: menu.quickUrl,
                            icon: menu.quickIcon
                        };
                    });

                    let createMenus = [newMenus];
                    this.createMenus = createMenus;
                    res(createMenus);
                });
            }).catch((error: any) => {
                rej(error);
            })
        });
    }
    @action
    getFriendMenu = async () => {
        const data = await API.getFriend()
        if (data?.data?.support) {
            runInAction(() => {
                this.myFriendMenu = data.data
            })
        }
    }

    //获取角标
    @action
    getTotalCount = async () => {
        return Promise.all([this.getFrontSingleNavigationMenuList(), this.getFriendMenu()]).then((results) => {
            let totalCount = 0
            const single_friend = this.menuList.find((item) => item.menuKey === "single_friend")
            const single_concern_per = this.menuList.find((item) => item.menuKey === "single_concern_per")
            if (single_friend?.menuEnable === 0 && single_concern_per?.menuEnable === 0) {
                totalCount = 0
            } else if (single_friend?.menuEnable === 0 && single_concern_per?.menuEnable === 1) {
                totalCount = this.focusPeopleCount
            } else if (single_friend?.menuEnable === 1 && single_concern_per?.menuEnable === 0) {
                //外部联系人不加载我的好友接口
                if (!isExternalTest() && this.myFriendMenu?.support) {
                    totalCount = this.myFriendMenuCount
                }
            } else if (single_friend?.menuEnable === 1 && single_concern_per?.menuEnable === 1) {
                if (!isExternalTest() && this.myFriendMenu?.support) {
                    totalCount = this.myFriendMenuCount + this.focusPeopleCount
                } else {
                    totalCount = this.focusPeopleCount
                }
            }
            runInAction(() => {
                this.cornerMarkValue.me = totalCount
            })
            return totalCount
        })
    }

    @action
    getPeopleMenuCount = () => {
        if (window.TEAMS?.currentUser?.userId && window.TEAMS?.currentUser?.userId === '4524556829951398584') {
            this.getFrontSingleNavigationMenuList()
            this.getFriendMenu()
            return
        }
        API.getPeopleMenuCount().then((data: any) => {
            runInAction(async () => {
                this.myFriendMenuCount = data?.data?.friend || 0;
                this.focusPeopleCount = data?.data?.attention || 0;
                const totalCount = await this.getTotalCount()
                if (inApp()) {
                    weappSDK.checkApi('refreshTabCount').then(() => {
                        weappSDK.exec('refreshTabCount', {
                            tabname: 'me',
                            // count: data?.data?.total || 0,
                            count: totalCount || 0,
                            success: () => {

                            }
                        })
                    })
                }
            })
        }).catch(() => {
            this.getFrontSingleNavigationMenuList()
            this.getFriendMenu()
        })
    }

    //获取前台列表
    @action
    getFrontSingleNavigationMenuList = async () => {
        const res = await queryFrontSingleNavigationMenuList();
        runInAction(() => {
            this.menuList = res.data
        })
    }


    //根据user_id和tenant_key查询外部联系人信息
    @action
    getExternalEmployees = async (callback?: Function) => {
        const res = await queryExternalEmployees()
        runInAction(() => {
            this.externalEmployeesList = res?.data || []
            callback && callback()
        })
    }


    //获取h5底部导航栏数据
    @action
    getH5NavMenuList = async (iFrameCallback: Function, activeTabCallback: Function) => {
        const res = await getNavMenuList()
        runInAction(() => {
            this.navMenuList = res?.data?.navList
            this.handleNavMenuList(iFrameCallback, activeTabCallback)
            console.log("navMenuList", this.navMenuList);
        })
    }

    @action
    handleNavMenuList = (iFrameCallback: Function, activeTabCallback: Function) => {
        this.navMenuList = this.navMenuList.filter((item: any) => {
            //私人备忘录（e006)、私人安排(e007)两个菜单是app原生的，h5不显示
            if (item.id === "em006" || item.id === "em007") {
                return false
            }
            return item.isenable === 1
        })
        const map = new Map([
            ['em001', 'im'],
            ['em004', 'contacts'],
            ['em003', 'fastmenu'],
            ['em002', 'apps'],
            ['em005', 'me'],
        ]);
        this.navMenuList.map((item: NavMenuItem) => {
            // item.name = getLabel(item.nameI18n, item.name)
            if (map.get(item.id)) {
                item.id = map.get(item.id) as string
            }
        })
        if (this.navMenuList.length > 5) {
            this.showMoreNavMenu = true
            this.moreNavMenuList = this.navMenuList.slice(5) as any
        }
        const activeId = localStorage.getItem(`WB_activeTab_${window.TEAMS?.currentUser?.id}`);
        let activeIdIndex = -1;
        const activeItem = this.navMenuList.find((item: NavMenuItem, index) => {
            if (item.id === activeId) {
                activeIdIndex = index;
                return true
            }
        }) as any
        const defaultTabs = ['im', 'apps', 'contacts', 'me', 'fastmenu']
        if (activeItem && activeItem.linkUrl && activeIdIndex <= 4 && (activeItem.openMode === 0 || activeItem.openMode === 3) && activeItem.id !== "em009") {
            let url = ""
            if (activeItem.linkUrl.indexOf("http") !== -1) {
                url = activeItem.linkUrl;
            } else if (activeItem.linkUrl[0] === "/") {
                url = getLocationOrigin() + activeItem.linkUrl;
            } else {
                url = "https://" + activeItem.linkUrl
            }
            setTitle({ title: activeItem.name as string })
            iFrameCallback && iFrameCallback(url)
            return
        } else if (defaultTabs.indexOf(activeItem?.id) !== -1) {
            return
        } else {
            //若菜单修改后,activeId不存在于底部菜单中，则默认设置一个activeId
            for (let i = 0; i < 5; i++) {
                const item = this.navMenuList[i] as any;
                if (((item.openMode === 0) || (item.openMode === 3)) && item.id !== "em009") {
                    if (item.linkUrl && defaultTabs.indexOf(item.id) === -1) {
                        let url = ""
                        if (item.linkUrl.indexOf("http") !== -1) {
                            url = item.linkUrl;
                        } else if (item.linkUrl[0] === "/") {
                            url = getLocationOrigin() + item.linkUrl;
                        } else {
                            url = "https://" + item.linkUrl
                        }
                        iFrameCallback && iFrameCallback(url)
                    }
                    setTitle({ title: item.name as string })
                    activeTabCallback && activeTabCallback(item.id)
                    return
                }
            }
        }
    }

}

const instance = new MobMainStore();

export default instance;
